import Iconify from "minimals-template/components/Iconify"
import LicenseCard from "./LicenseCard"
import VertcialCenterGridItem from "./VertcialCenterGridItem"
import { Box, List, Typography } from "@mui/material"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTheme } from "@mui/styles"
import { NoLicenseShareLinkItem } from "plugins/Paywall/components/NoLicenseShareLinkItem"

export function ShareLinkContactCard({ selected, onSelect }) {
    const theme = useTheme()
    const collaborateColor = theme.palette.license.collaborate
    const { links = [] } = useBoundContext()
    const hasViewableLinks = links.some((link) => link.canViewWithoutLicense)
    const title = getTitle()
    const description = getDescription()

    return (
        <VertcialCenterGridItem>
            <LicenseCard borderColor={collaborateColor}>
                <Box
                    sx={{
                        alignItems: "flex-start",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        width: "100%",
                        flex: 1,
                        minHeight: 550,
                    }}
                >
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 0 }}>
                            {title}
                        </Typography>
                        <Iconify icon="material-symbols:share-outline" width={34} height={34} color="#38939B" />
                    </Box>
                    <Typography variant="body2">{description}</Typography>
                    <List
                        sx={{
                            width: "100%",
                            bgcolor: "transparent",
                            boxShadow: "none",
                            borderRadius: 3,
                            mb: 0,
                            pt: 0,
                            pb: 0,
                            height: 1,
                            flex: 1,
                            minHeight: 100,
                        }}
                    >
                        <PagedRepeat
                            overridePageSize={2}
                            list={links}
                            pass="link"
                            showPageSize={false}
                            item={<NoLicenseShareLinkItem selected={selected} onSelect={onSelect} />}
                        />
                    </List>
                </Box>
            </LicenseCard>
        </VertcialCenterGridItem>
    )

    function getTitle() {
        if (hasViewableLinks) return "Shared schedules available"
        return "Share links available"
    }

    function getDescription() {
        if (hasViewableLinks) return "You can open these share links without buying a licence."
        return "You will need a collaborate licence in order to view SFG20 data shared with you."
    }
}
